export interface Sender {
    name: string
    email: string
}

export function parseSender(from: string): Sender {
    // Handle format like: "Miki from Tailride <miki@marketing.tailride.so>"
    const match = from.match(/^(.+?)\s*<(.+)>$/)
    if (match) {
        return {
            name: match[1].trim().replace(/["']/g, ''),
            email: match[2].trim(),
        }
    }

    // Fallback: if no match, assume the whole string is the email
    return {
        name: '',
        email: from,
    }
}
